import React from 'react';
import { Clock, User, AlertTriangle } from 'lucide-react';
interface TrainingBlockProps {
  training: any;
  trainingType: any;
  instructor: any;
  style: React.CSSProperties;
  hasOverlap: boolean;
  onClick: () => void;
}
export function TrainingBlock({
  training,
  trainingType,
  instructor,
  style,
  hasOverlap,
  onClick
}: TrainingBlockProps) {
  // Function to get color class based on training type
  const getColorClass = (color: string) => {
    const colorMap = {
      blue: 'bg-blue-100 border-blue-300 text-blue-800',
      green: 'bg-green-100 border-green-300 text-green-800',
      purple: 'bg-purple-100 border-purple-300 text-purple-800',
      yellow: 'bg-yellow-100 border-yellow-300 text-yellow-800',
      red: 'bg-red-100 border-red-300 text-red-800'
    };
    return colorMap[color] || 'bg-gray-100 border-gray-300 text-gray-800';
  };
  // Format time (e.g., "09:00")
  const formatTime = (date: Date) => {
    return date.toLocaleTimeString('nl-NL', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    });
  };
  return <div className={`absolute rounded-md border p-2 cursor-pointer transition-all hover:shadow-md ${getColorClass(trainingType.color)} ${hasOverlap ? 'border-2 border-red-500' : ''}`} style={style} onClick={onClick} data-id="element-3108">
      <div className="flex flex-col h-full" data-id="element-3109">
        <div className="font-medium text-xs truncate" data-id="element-3110">{trainingType.name}</div>
        <div className="text-xs flex items-center mt-1" data-id="element-3111">
          <Clock className="h-3 w-3 mr-1" data-id="element-3112" />
          <span data-id="element-3113">
            {formatTime(training.startTime)} - {formatTime(training.endTime)}
          </span>
        </div>
        <div className="text-xs flex items-center mt-1" data-id="element-3114">
          <User className="h-3 w-3 mr-1" data-id="element-3115" />
          <span className="truncate" data-id="element-3116">{instructor.name}</span>
        </div>
        <div className="text-xs mt-1" data-id="element-3117">
          <span data-id="element-3118">{training.participants} deelnemers</span>
        </div>
        {hasOverlap && <div className="mt-auto pt-1 text-red-600 text-xs flex items-center" data-id="element-3119">
            <AlertTriangle className="h-3 w-3 mr-1" data-id="element-3120" />
            <span data-id="element-3121">Conflict!</span>
          </div>}
      </div>
    </div>;
}